const restReducer = (state=[], {type, data}) => {
    switch (type) {
        case 'SET_SELECTED_RESTAURANT':
            return data;
        default: 
            return state;
    }
}

export default restReducer;